import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { AppBar, styled } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from './UserContex';
import { useHistory } from 'react-router';
import { isMobileKeyboardOpen } from '../utils/Keyboard';
import { getAuth, signOut } from 'firebase/auth';

const navStyle = { '&.Mui-selected': { color: '#fff' } };
const path = { '/': 0, '/register': 1, '/account': 2, '/login': 2 }[window.location.pathname];

const Image = styled('img')({
  height: '38px',
  width: '38px',
  objectFit: 'cover',
  objectPosition: 'center',
  borderRadius: '50%',
  margin: 'auto',
});

const Navigation = () => {
  const [selected, setSelected] = useState(path);
  const [keyboard, setKeyboard] = useState(false);
  const [accountObj, setAccountObj] = useState(null);

  useEffect(() => {
    setAccountObj(JSON.parse(localStorage.getItem('accountObj')));
  }, []);

  const user = useContext(UserContext);
  const history = useHistory();

  const navigateTo = (url) => {
    history.push(url);
  };

  const signOutUser = () => {
    // remove cached accountObj
    if (localStorage.getItem('accountObj')) {
      localStorage.removeItem('accountObj');
    }

    signOut(getAuth());
    history.push('/');
  };

  // checks if mobile keyboard is open and hides bottom nav if it is
  window.visualViewport.addEventListener('resize', () => setKeyboard(isMobileKeyboardOpen()));

  return (
    <>
      {!keyboard && (
        <AppBar position="fixed" color="primary" style={{ top: 'auto', bottom: 0 }}>
          <BottomNavigation
            showLabels
            sx={{ background: '#f21905', height: '75px', paddingBottom: '15px' }}
            value={selected}
            onChange={(event, newValue) => {
              setSelected(newValue);
            }}
          >
            <BottomNavigationAction onClick={() => navigateTo('/')} label="Hjem" icon={<HomeIcon />} sx={navStyle} />
            <BottomNavigationAction
              onClick={() => navigateTo('/register')}
              label="Tidsbruk"
              icon={<AddCircleIcon />}
              sx={navStyle}
            />
            {accountObj?.profileImage && user ? (
              <BottomNavigationAction
                onClick={() => navigateTo(user ? '/account' : '/login')}
                icon={<Image src={accountObj?.profileImage} alt="profile" />}
                sx={navStyle}
                showLabel={false}
              />
            ) : (
              <BottomNavigationAction
                onClick={() => navigateTo(user ? '/account' : '/login')}
                label={user ? 'Bruker' : 'Logg inn'}
                icon={user ? <PersonIcon /> : <LoginIcon />}
                sx={navStyle}
              />
            )}

            {user && (
              <BottomNavigationAction onClick={() => signOutUser()} label="Logg ut" icon={<LogoutIcon />} sx={navStyle} />
            )}
          </BottomNavigation>
        </AppBar>
      )}
    </>
  );
};

export default Navigation;
